import React from 'react';
import Widget from "../../../../../components/prefabricated/Widget";
import {HashLink as Link} from "react-router-hash-link";
import {Col, Row} from "reactstrap";
import UpdateCustomerNameDialog
    from "../../../../../components/customBreachBits/admin/BRCustomersTable/UpdateCustomerNameDialog";
import {useSelector} from "react-redux";
import {bbIsUserManagerOfEntity, isCurrentUserMemberOf} from "../../../../../util/bbHelpers";

const CustomerInformationPane = ({customer = null, myEntity = null, ownershipVerified = false}) =>{

    const {authUser} = useSelector(({auth}) => auth);
    const isAdminStaff = isCurrentUserMemberOf(authUser, "admin") || isCurrentUserMemberOf(authUser, "staff")
    const { entityInView } = useSelector(({breachrisk}) => breachrisk);
    const authUserIsManager = bbIsUserManagerOfEntity(authUser, entityInView);


    return(
        <div className={"col-12 text-center"}>
                {/*<h1 >Company Information</h1>*/}
                <Widget>
                    <Row>
                        <Col>
                            <h2 className={"text-center"}>
                                {isAdminStaff || (authUserIsManager && ownershipVerified)
                                    ? <UpdateCustomerNameDialog customerId={customer && customer.CustomerId ? customer.CustomerId : null}>
                                    {customer && customer.CustomerName
                                        ? customer.CustomerName
                                        : "--"}
                                </UpdateCustomerNameDialog>
                                :<>{customer && customer.CustomerName
                                        ? customer.CustomerName
                                        : "--"}
                                    </>}
                            </h2>

                        </Col>
                    </Row>

                    <Row>
                        <Col>
                            <br/>
                        </Col>
                    </Row>

                    <Row>
                        <Col>
                            <p>
                                <strong>Primary Domains:</strong> {customer && customer.CustomerDomains ? customer.CustomerDomains : "--"}
                            </p>
                        </Col>
                    </Row>

                    <Row>
                        <Col>
                            <p>
                                <strong>Website:</strong> {customer &&  customer.CustomerIpAddresses ? customer.CustomerIpAddresses : "--"}
                            </p>
                        </Col>
                    </Row>


                    {/*{(customer && isBRBusinessCustomer && (providedDomains || providedTargets || providedSubdomains)) &&*/}
                    {/*<em>See a full <Link to={"/board/BreachRisk/Business/Verifications"}>  list of IPs, Domains, and Subdomains provided</Link>.*/}
                    {/*</em>*/}

                    {/*}*/}
                    {/*<hr/>*/}
                    {/*{customer && customer["Customer Size"] &&*/}
                    {/*<p>*/}
                    {/*    <strong>Size:</strong> {customer["Customer Size"]["Name"] ? customer["Customer Size"]["Name"] : "--"} ({customer["Customer Size"]["Customer Size"] ? customer["Customer Size"]["Customer Size"] : "--"})*/}
                    {/*</p>*/}
                    {/*}*/}
                    {/*{customer && customer["Customer Industry"] &&*/}
                    {/*<p>*/}
                    {/*    <strong>Industry:</strong> {customer["Customer Industry"].Name ? customer["Customer Industry"].Name : "--"}*/}
                    {/*</p>*/}
                    {/*}*/}
                    {/*{customer && customer["Timezone"] &&*/}
                    {/*    <p>*/}
                    {/*    <strong>Timezone:</strong> {customer["Timezone"] ? customer["TimeZone"] : "--"}*/}
                    {/*</p>}*/}
                </Widget>
        </div>
    )
}

export default CustomerInformationPane;